import { Directive, OnChanges, SimpleChanges, Input, Renderer2, ElementRef } from '@angular/core';

@Directive({
  selector: '[vrmIndexingRatingBg]',
})
export class VrmIndexingRatingBgDirective implements OnChanges {
  @Input() indexingRatingColor: string = '';

  constructor(private renderer: Renderer2, private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['indexingRatingColor']) {
      let backgroundColor = 'green';

      if (this.indexingRatingColor) {
        switch (this.indexingRatingColor.toLowerCase()) {
          case 'black': {
            backgroundColor = 'black';
            break;
          }

          case 'red': {
            backgroundColor = 'red';
            break;
          }

          case 'yellow': {
            backgroundColor = 'orange';
            break;
          }

          case 'green': {
            backgroundColor = 'green';
            break;
          }
        }
      }

      if (backgroundColor) {
        this.renderer.setStyle(this.elementRef.nativeElement, 'background-color', `${backgroundColor}`);
      }
    }
  }
}
